<div class:bx--toolbar-content="{true}">
  <slot />
</div>
